module.exports = __webpack_public_path__ + "img/emoji-love.a3dd688c.png";